import { Tile, NumberFormatter } from "@uicore";
import { Stack } from "@altimateai/lego";
import { useAppState } from "@/modules/app/useAppContext";
import classes from "../../../summary/summary.module.scss";

interface Props {
  title: string;
  helpText: string;
  total: number;
  breakdown: { key: string; label: string; value: number }[];
}

const DatabricksCostTotalsTile = ({ title, helpText, total, breakdown }: Props) => {
  const { currency } = useAppState();
  return (
    <div className={classes.tileWrap}>
      <Tile
        color="#FF754C"
        title={title}
        helpText={helpText}
        value={<NumberFormatter value={total} options={{ currency }} />}
      >
        <Stack direction="column">
          {breakdown.map(({ key, label, value }) => (
            <Tile
              key={key}
              title={label}
              value={<NumberFormatter value={value} options={{ currency }} />}
            />
          ))}
        </Stack>
      </Tile>
    </div>
  );
};

export default DatabricksCostTotalsTile;
